import { useSyncExternalStore } from 'react';

/**
 * O stream SSE de notificações está de pé? Há um único stream por aplicação, aberto pelo `NotificationsProvider`.
 * Fica fora do contexto para que quem depende de evento em tempo real (tarefas do usuário) funcione também sem o
 * provider (testes, telas sem header): aí o stream conta como fora do ar e a consulta periódica assume.
 */
let streamOpen = false;
const listeners = new Set<() => void>();

export const setNotificationStreamOpen = (open: boolean) => {
  streamOpen = open;
  listeners.forEach((listener) => listener());
};

const subscribe = (listener: () => void) => {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};

export const useNotificationStreamOpen = () => useSyncExternalStore(subscribe, () => streamOpen);
